import { Injectable } from '@angular/core';
import { DateService } from '../date/date.service';

@Injectable()
export class UtilityService {
  constructor() {}

  /**
   * @description: Patch homepage component's date to other component's state
   * @param initialState component's initial state to which date needs to be patched
   * @param payload data containing duration days and time range selected in homepage
   */
  public patchDateToState(initialState, payload) {
    const dateService = new DateService();
    const { days, startDate: from, endDate: to } = payload;
    return {
      ...initialState,
      days: days,
      displayStartDate: from,
      displayEndDate: to,
      paramStartDate: dateService.toDaysStartISO(from),
      paramEndDate: dateService.toDaysEndISOPlusOne(to),
    };
  }
}
